import errors from '@/store/modules/errors/erorrs'

export default {
  errors
}
